import { toast } from 'sonner';

// Helper function to dismiss all toasts and show a new one
export const showSingleToast = (message, type = 'success') => {
  toast.dismiss();
  if (type === 'success') {
    toast.success(message);
  } else if (type === 'error') {
    toast.error(message);
  }
};
